import { render, staticRenderFns } from "./TwoColumns.vue?vue&type=template&id=6c225e31&scoped=true&"
import script from "./TwoColumns.vue?vue&type=script&lang=ts&"
export * from "./TwoColumns.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c225e31",
  null
  
)

export default component.exports